import { Undo } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconUndo12Line = createIcon(Undo, 12, "Line");
export const IconUndo16Line = createIcon(Undo, 16, "Line");
export const IconUndo20Line = createIcon(Undo, 20, "Line");
export const IconUndo24Line = createIcon(Undo, 24, "Line");
export const IconUndo32Line = createIcon(Undo, 32, "Line");
export const IconUndo48Line = createIcon(Undo, 48, "Line");
export const IconUndo64Line = createIcon(Undo, 64, "Line");
